import styles from './UserThumb.module.scss';
import sharedStyles from '@/modules/opinions/Shared.module.scss';

import { Avatar } from '@/components';
import { useOpinionContext } from '@/modules/opinions';
import { useStore } from '@/store';
import { formatNumber } from '@/utils';
import cn from 'classnames';

import { useEffect, useRef } from 'react';

export const UserThumb = () => {
  const userThumb = useRef<HTMLDivElement>(null);
  const {
    accountStore: {
      accountData: { _id },
    },
  } = useStore();

  const { opinion, isDragEnded, isVoted } = useOpinionContext();

  useEffect(() => {
    if (!userThumb.current || !isVoted) return;
    if (opinion.predictPercentage == null) return;

    const parentWidth = userThumb.current.parentElement!.offsetWidth;
    const thumbWidth = userThumb.current.offsetWidth;
    const positionX = (opinion.predictPercentage / 100) * parentWidth;
    const thumbPosition = Math.round(
      Math.max(
        0,
        Math.min(positionX - thumbWidth / 2, parentWidth - thumbWidth),
      ),
    );
    userThumb.current.style.left = `${thumbPosition}px`;
  }, [isVoted]);

  if (opinion.predictPercentage == null) return '';

  return (
    <div
      ref={userThumb}
      className={cn(
        styles.thumb,
        styles.usersThumb,
        isDragEnded && sharedStyles.opacity1,
        !isVoted && sharedStyles.hidden,
      )}
    >
      <div className={styles.userAvatar}>
        <Avatar className={styles.userImage} _id={_id} />
      </div>
      <div className={styles.usersOpinion}>
        {formatNumber(opinion.predictPercentage)}%
      </div>
    </div>
  );
};
